import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiFaqSectionDTO extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  source: "All" | "HomepageFeatured";
  curatedQuestions?: { documentId?: string; question?: string }[];
  emitStructuredData: boolean;
}

export class FaqSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  source: "All" | "HomepageFeatured";
  /** documentIds of hand-picked questions; when non-empty they override `source` */
  curatedQuestionIds: string[];
  emitStructuredData: boolean;
}
